<template>
  <v-dialog
    v-model="dialog"
    max-width="390"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        icon
        small
        class="mt-n1"
        :disabled="disabled"
        v-on="on"
      >
        <v-icon>{{ textIcon }}</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
      >
        <v-toolbar-title>
          {{ textHeader }}
        </v-toolbar-title>
        <v-spacer />

        <v-btn
          icon
          dark
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-text-field
          v-model="text"
          :label="label"
          :rules="[v => !!v || 'Campo obrigatório']"
          outlined
          rounded
          dense
        />
      </v-card-text>

      <v-card-actions>
        <v-row dense>
          <v-col cols="auto">
            <v-btn
              color="error"
              rounded
              class="text-none"
              @click="dialog = false"
            >
              <v-icon
                dark
                left
              >
                mdi-minus-circle
              </v-icon>
              Cancelar
            </v-btn>
          </v-col>
        </v-row>
        <v-col cols="auto">
          <v-btn
            color="success"
            rounded
            class="text-none"
            @click="submitText"
          >
            <v-icon
              dark
              left
            >
              mdi-checkbox-marked-circle
            </v-icon>
            Adicionar
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'SendText',
    props: {
      textHeader: {
        type: String,
        default: 'Adicionar Item',
      },
      textIcon: {
        type: String,
        default: 'mdi-plus',
      },
      label: {
        type: String,
        default: 'Item',
      },
      sendText: {
        type: Function,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        text: '',
        dialog: false,
      }
    },

    methods: {
      submitText () {
        if (!this.text) return
        const send = { texto: this.text }
        const retorno = this.sendText(send)
        if (retorno) {
          this.dialog = false
          this.text = ''
        }
      },
    },

  }
</script>
